const initialize = ($productList) => {
    const $sidebarCategoryNavigation = $productList.querySelector('.sidebar-category-navigation-wrapper');

    if (!$sidebarCategoryNavigation) {
        return;
    }

    $productList.style.minHeight = `${$sidebarCategoryNavigation.getBoundingClientRect().height}px`;
};

(() => {
    const $productLists = document.body.querySelectorAll('.product-list');
    Array.prototype.forEach.call($productLists, initialize);
})();
